import {createApp} from 'vue';
import ImportDatasources from "@/vue/datasourceAdmin/ImportDatasources.vue";

const queryBuilderApp = createApp(ImportDatasources);

queryBuilderApp.mount('#import-datasources');